module.exports = __webpack_public_path__ + "media/Nature is in danger SF rough Mix.218a7f74.mp3";